// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

import { getProxyBaseURL } from '@/api/http';
import { getAuthStore } from '@/store/authStore';

/**
 * The product pages call the legacy server directly: a JSON error body there
 * is an HTTP error (the shared proxy client would hand it back as data), so
 * this keeps the plain fetch-and-check the pages were written against.
 */
export async function productFetch(
  path: string,
  init: RequestInit = {}
): Promise<Response> {
  const { token } = getAuthStore();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(`${await getProxyBaseURL()}${path}`, { ...init, headers });
}

export async function failure(res: Response): Promise<Error> {
  const body = (await res.json().catch(() => ({}))) as { detail?: string };
  return new Error(body.detail ?? `HTTP ${res.status}`);
}
